<template>
  <div class="contact-panel" :class="properClass">
    <p class="contact-panel__title">Past Present Print</p>
    <div class="contact-panel__details">
      <div class="contact-panel__detail">
        <span class="contact-panel__label">author</span>
        <div class="contact-panel__values">
          <p class="contact-panel__value">Lena Mitkowa</p>
          <p class="contact-panel__value">
            <a
              href="https://lenivastudio.com/"
              target="_blank"
              rel="noopener noreferrer"
            >Leniva&deg; Studio</a>
          </p>
        </div>
      </div>
      <div class="contact-panel__detail">
        <span class="contact-panel__label">partners</span>
        <div class="contact-panel__values">
          <p class="contact-panel__value">
            <a href="https://www.stgu.pl/" target="_blank" rel="noopener noreferrer">STGU</a>
          </p>
          <p class="contact-panel__value">Projekt Przedruk</p>
          <p class="contact-panel__value">
            <a
              href="https://lenivastudio.com/"
              target="_blank"
              rel="noopener noreferrer"
            >Leniva&deg; Studio</a>
          </p>
        </div>
      </div>
      <div class="contact-panel__detail">
        <span class="contact-panel__label">contact</span>
        <div class="contact-panel__values">
          <p class="contact-panel__value">
            <a href="mailto:przedruk@przedruk.org">przedruk@przedruk.org</a>
          </p>
        </div>
      </div>
    </div>
    <SocialMedia :icon="isMobile ? 'hand':'arrow'" />
  </div>
</template>

<script>
import SocialMedia from "./SocialMedia";

export default {
  name: "ContactPanel",
  props: {
    active: Boolean,
    isPostActive: Boolean,
    isMobile: Boolean,
    isBackgroundPrimary: Boolean,
    screenLevel: String,
    isPolicyPrivacyOpen: Boolean
  },
  components: {
    SocialMedia
  },
  computed: {
    properClass: function() {
      let output = "";

      if (this.active) {
        output = "active";
      }

      if (this.isMobile) {
        output += " contact-panel--mobile";
      }

      if (
        (!this.isBackgroundPrimary || this.screenLevel === "bottom") &&
        !this.isPostActive &&
        !this.isPolicyPrivacyOpen
      ) {
        output += " white";
      }

      return output;
    }
  }
};
</script>

<style lang="scss">
.contact-panel {
  position: fixed;
  left: 10px;
  bottom: 0;
  height: calc(100vh - 200px);
  width: calc(100% - #{$main-width} - 10px);
  padding: 20px 20px 100px $screen-gutter-left + 22px;
  // background-color: $primary-color;
  transition: 0.4s ease-in-out;
  z-index: 20;
  opacity: 0;
  visibility: hidden;

  &.active {
    opacity: 1;
    visibility: visible;
  }

  &--mobile {
    background-color: $primary-color;
    z-index: 50;
    animation: fadeIn 0.5s ease-in-out;
    width: 100%;
    padding-left: calc(6% + 20px);

    .socials--hand.socials--hand {
      left: calc(6% + 20px);
      width: calc(100% - 6% - 40px);
      bottom: 45px;
      align-items: flex-end;

      img {
        margin-right: 3%;
      }
    }

    &.white {
      background-color: #fff;
    }

    .contact-panel__detail {
      &:not(:last-child) {
        margin-bottom: 10px;
      }
    }
  }

  &__title {
    margin-bottom: 40px;
  }

  &__details {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: calc(100% - 53px);
    max-height: 300px;
  }

  &__detail {
    display: flex;
    line-height: 25px;

    a {
      &:hover {
        text-decoration: underline;
      }
    }
  }

  &__label {
    flex: 0 1 40%;
  }

  .socials {
    margin-top: 0;
    position: absolute;
    bottom: $screen-gutter-bottom - 3px;
    left: $screen-gutter-left + 22px;
    width: calc(100% - 67px - 20px);

    .social {
      &--facebook {
        position: absolute;
        bottom: 0;
        left: 0;

        & + a {
          margin-left: 40%;
        }
      }
    }

    img {
      width: 34px;
    }
  }
}
</style>